import { useVIP } from '../../hook'
import { useUpdateVIPProgram } from '../../context/useMutation'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { Modal } from 'react-bootstrap'
import { useState } from 'react'

export default function ProgramBody({
  refetch
}: {
  refetch: () => void
}) {
  const intl = useIntl()
  const { program } = useVIP()
  const { mutateAsync, isLoading } = useUpdateVIPProgram()

  const [show, setShow] = useState(false)

  const onSubmit = async () => {
    if (!program) return

    if (
      !program.startDate ||
      !program.storeID ||
      !program.entryMethodType ||
      !program.expirationType ||
      !program.status
    ) {
      toast.error(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' }))
      return
    }

    await mutateAsync({
      values: {
        ...program,
        status: program.status === 1 ? 2 : 1
      }
    })
    refetch()
  }

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{intl.formatMessage({ id: 'VIP.PROGRAM.SURE' })}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {intl.formatMessage({ id: 'VIP.PROGRAM.SURE.DESC' })}
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-danger' onClick={() => setShow(false)}>
            {intl.formatMessage({ id: 'GLOBAL.BUTTON.CANCEL' })}
          </button>
          <button
            className='btn btn-primary'
            disabled={isLoading}
            onClick={async () => {
              onSubmit()
              setShow(false)
            }}
          >
            {intl.formatMessage({ id: 'GLOBAL.BUTTON.UPDATE' })}
          </button>
        </Modal.Footer>
      </Modal>
      <div className='card mt-10'>
        <div className='card-header'>
          <div className='card-title d-flex flex-column'>
            <div className='d-flex align-items-center position-relative my-3'>
              <h3>{intl.formatMessage({ id: 'VIP.PROGRAM.STATUS' })}</h3>
              {program?.status === 1 ? (
                <span className='badge bg-success text-light ms-3'>
                  {intl.formatMessage({ id: 'GLOBAL.ACTIVE' })}
                </span>
              ) : (
                <span className='badge bg-danger text-light ms-3'>
                  {intl.formatMessage({ id: 'GLOBAL.INACTIVE' })}
                </span>
              )}
            </div>
            <span className='fs-6 text-muted mb-4'>
              {intl.formatMessage({ id: 'VIP.PROGRAM.STATUS.DESC' })}
            </span>
          </div>
          <div className='card-toolbar'>
            <button className='btn btn-primary' onClick={() => setShow(true)} disabled={isLoading}>
              {isLoading ? (
                intl.formatMessage({ id: 'LOADING' })
              ) : (
                <>
                  {program?.status === 1
                    ? intl.formatMessage({ id: 'GLOBAL.BUTTON.OFF' })
                    : intl.formatMessage({ id: 'GLOBAL.BUTTON.ON' })}
                </>
              )}
            </button>
          </div>
        </div>
      </div >
    </>
  )
}
